import { IconButton, Tooltip as MuiTooltip, Typography } from 'ui';

export const Tooltip = ({ title, color, icon }: { title: string; color?: string; icon?: React.ReactNode }) => {
  return (
    <MuiTooltip
      PopperProps={{
        popperOptions: {
          modifiers: [
            {
              name: 'offset',
              options: { offset: [0, -10] },
            },
          ],
        },
      }}
      title={
        <Typography
          variant="subtitle2"
          sx={{
            width: 140,
          }}
        >
          {title}
        </Typography>
      }
      placement="top"
    >
      <IconButton
        sx={{
          color: color || 'primary.dark',
        }}
      >
        {icon}
      </IconButton>
    </MuiTooltip>
  );
};
